/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { jsx, type ElementProps } from '@amazon/vinyl-tsx'
import { notSignedIn } from '@/auth/authRef'
import { startSignIn } from '@/metrics/startSignIn'
import { isTv } from '@/device/deviceConfig'
import { getString } from '@/header/i18n/bundle.generated'
import { getString as getAuthString } from '@/auth/i18n/bundle.generated'

export type AnonymousBannerProps = ElementProps<'div'>

export function AnonymousBanner(props: AnonymousBannerProps) {
    if (isTv()) {
        return null
    }

    return (
        <div className="anonymousBanner notificationRibbon" visible={notSignedIn()} {...props}>
            <span className="bannerText">{getAuthString('dmusic_sign_in_banner_text')}</span>
            <button className="textButton signInBannerBtn" onclick={() => startSignIn()}>
                {getString('dmusic_signin_button_text')}
            </button>
        </div>
    )
}
